const exams = [
  {
    slug: "upsc",
    title: "UPSC Preparation",
    description:
      "Current affairs, MCQs, PDFs and daily practice for UPSC Civil Services.",
  },
  {
    slug: "ssc",
    title: "SSC Preparation",
    description:
      "Exam-focused current affairs and MCQs for SSC CGL, CHSL, MTS.",
  },
  {
    slug: "banking",
    title: "Banking Exams",
    description:
      "Daily current affairs & MCQs for SBI, IBPS, RBI exams.",
  },
  {
    slug: "railway",
    title: "Railway Exams",
    description:
      "Current affairs & practice questions for RRB exams.",
  },
  {
    slug: "state-psc",
    title: "State PSC Exams",
    description:
      "State-level current affairs & MCQs for PSC exams.",
  },
  {
    slug: "gpsc",
    title: "GPSC Preparation",
    description:
      "Gujarat PSC current affairs & exam-specific MCQs.",
  },
  {
    slug: "bpsc",
    title: "BPSC Preparation",
    description:
      "Bihar PSC current affairs & MCQs.",
  },
  {
    slug: "mppsc",
    title: "MPPSC Preparation",
    description:
      "Madhya Pradesh PSC current affairs & MCQs.",
  },
];

export default exams;
